
import axios from "axios"
import router from '../../router';
import { func } from '../../main';



const state = {
    OtherWorkTypeList: [],
    OtherWorkTypeListForEdit: [],
    OtherWorkTypeNo: "",
    OrgJobList:[],
    Loading:false,
    OtherWorkTypeAccess:"0"
};


const getters = {
    GetOtherWorkTypeList(state:any) {
        return state.OtherWorkTypeList;
    },
    GetOtherWorkTypeListForEdit(state:any) {
        return state.OtherWorkTypeListForEdit;
    },
    GetOtherWorkTypeNo(state:any) {
        return state.OtherWorkTypeNo;
    },
    GetOtherWorkTypeAccess(state:any){
        return state.OtherWorkTypeAccess;
    }
};

const mutations = {

    SetOtherWorkTypeList(state:any, list:any) {
        state.OtherWorkTypeList = list;
    },
    SetOtherWorkTypeListForEdit(state:any, list:any) {
        state.OtherWorkTypeListForEdit = list;
    },
    SetOtherWorkTypeNo(state:any, no:any) {
        state.OtherWorkTypeNo = no;
    },
    SetOtherWorkTypeAccess(state:any,no:any){
        state.OtherWorkTypeAccess=no;
    }
  
};

const actions = {
    GetOtherWorkTypeListFromServer(context:any, Filter:any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        //context.commit("SetLoading", true);
        axios.get("OtherWork/GetOtherWorkTypeList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey:Filter.searchKey
            }
        })
           .then((data: any) => {
                //context.commit("SetLoading", false);
                context.commit("SetOtherWorkTypeList", data.data);
            });
    },
    GetOtherWorkTypeListForEditFromServer(context: { commit: (arg0: string, arg1: boolean) => void; }, Filter: { pageId?: any; filterId?: any; searchKey: any; } | null) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("OtherWork/GetOtherWorkTypeListForEdit", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey: Filter.searchKey
            }
        })
            .then((data: any) => {
                context.commit("SetLoading", false);
                context.commit("SetOtherWorkTypeListForEdit", data.data);
            });
    },
   
    ClearOtherWorkTypeList(context: { commit: (arg0: string, arg1: never[]) => void; }) {
        context.commit("SetOtherWorkTypeList", []);
    },
   
    CreateOtherWorkType(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);

        axios.post('OtherWork/OtherWorkTypeCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                router.go(-1);
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    GetOtherWorkTypeAccess(context:any) {
        axios.get("OtherWork/CanViewOtherWorkType")
           .then(data => {
            context.commit("SetOtherWorkTypeAccess", data.data.toString());
            });
    },
    EditOtherWorkType(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);

        axios.post('OtherWork/OtherWorkTypeCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                router.go(-1);
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
